import { render, staticRenderFns } from "./PainelMDA.vue?vue&type=template&id=30063c98"
import script from "./PainelMDA.vue?vue&type=script&lang=js"
export * from "./PainelMDA.vue?vue&type=script&lang=js"
import style0 from "./PainelMDA.vue?vue&type=style&index=0&id=30063c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports